const showEmailEditor = () => Boolean(window.VUE_EMAIL_EDITOR)

export default showEmailEditor
